import React from 'react';
import {exportToXlsx} from '../xlsxUtils';

export default ({ data }) => <div><button onClick={() => exportToXlsx(data()) }>Last ned</button></div>;



// WEBPACK FOOTER //
// ./src/HrcsEditor/input/DownloadButton.js